module.exports = __webpack_public_path__ + "img/couples_19_V.ef378b48.webp";